import { Point } from "@nivo/line";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

const formatter = new Intl.NumberFormat(undefined, {
  notation: "compact",
  style: "decimal",
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

type ChartTooltipProps = {
  value: Point;
  color?: string;
};

export const ChartTooltip = ({ value, color }: ChartTooltipProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center px-3 py-2 bg-white rounded-sm shadow-md gap-x-2">
      {color && <div className="w-3 h-3 rounded-xs shrink-0" style={{ backgroundColor: color }} />}
      <div className="flex items-center text-xs text-left  text-platform-blue-950 gap-x-1">
        <span className="font-bold">{value.data.x.toString()}</span>
        <span>
          {t(`sidebar.selection.traffic_counts.vehicle_types.${value.serieId}`) +
            " " +
            formatter.format(value.data.y as number)}
        </span>
      </div>
    </div>
  );
};
